export default "__VITE_ASSET__sUn3WayS__"